import React from "react";
import style from "css/template.module.css";
import SitemapItem from "./sitemapItem";

/**
 * Version : 1.0
 * 작성일자 : 2025-02-10
 * 작성자 : 강연승
 * 설명 : 리브 홈페이지 footer 사이트맵
 */

function Sitemap() {
  const space = {
    main: { label: "스마트워크 스페이스", location: "smart-space/work" },
    sub: [
      { label: "가상 리셉셔니스트", location: "smart-space/work/reception" },
      { label: "자율좌석제", location: "smart-space/work/hotdesk" },
      {
        label: "회의실 예약 시스템",
        location: "smart-space/work/conference",
      },
      {
        label: "화상회의 시스템",
        location: "smart-space/work/videoconference",
      },
      { label: "스마트 워크 플랫폼", location: "smart-space/work/platform" },
      {
        label: "무선 컨퍼런싱 시스템",
        location: "smart-space/work/presentation",
      },
    ],
  };
  const lecture = {
    main: {
      label: "스마트 강의실/교실",
      location: "smart-space/room",
    },
    sub: [
      {
        label: "하이브리드 스마트 강의실",
        location: "smart-space/room/classRoom",
      },
      {
        label: "하이브리드 그룹 강의실",
        location: "smart-space/room/group",
      },
      {
        label: "하이브리드 스마트 실습실",
        location: "smart-space/room/lab",
      },
      {
        label: "하이브리드 스마트 연구실/교수실",
        location: "smart-space/room/laboratory",
      },
    ],
  };

  const telehelth = {
    main: {
      label: "스마트 텔레헬스 시스템",
      location: "smart-space/telehealth",
    },
    sub: [
      {
        label: "스마트 원격진료 시스템",
        location: "smart-space/telehealth/telehealth",
      },
      {
        label: "스마트 원격회진 시스템",
        location: "smart-space/telehealth/telerounding",
      },
      {
        label: "스마트 원격협진 시스템",
        location: "smart-space/telehealth/telecollaboration",
      },
      {
        label: "의료세미나/학술대회",
        location: "smart-space/telehealth/symposium",
      },
      // {
      //   label: "맞춤형 통합 구축 플랫폼",
      //   location: "smart-space/platform",
      // },
    ],
  };

  const cafe = {
    main: {
      label: "하이브리드 스마트 카페/도서관",
      // location: "smart-space/cafe",
    },
  };

  const neat = {
    main: {
      label: "AI 화상회의 장비, neat",
      // location: "smart-device/neat",
    },
    sub: [
      {
        label: "neat.bar",
        location: "smart-device/neat/bar",
      },
      {
        label: "neat.bar generation2",
        location: "smart-device/neat/bar2",
      },
      {
        label: "neat.bar pro",
        location: "smart-device/neat/barPro",
      },
      {
        label: "neat.board50",
        location: "smart-device/neat/board50",
      },
      {
        label: "neat.board pro",
        location: "smart-device/neat/boardPro",
      },
      {
        label: "neat.frame ",
        location: "smart-device/neat/frame",
      },
      {
        label: "neat.center",
        location: "smart-device/neat/center",
      },
      {
        label: "neat.pad",
        location: "smart-device/neat/pad",
      },
    ],
  };
  const clickshare = {
    main: {
      label: "무선 프레젠테이션 시스템, ClickShare",
      location: "smart-device/clickshare",
    },
  };

  const allplace = {
    main: {
      label: "All Place",
      location: "smart-solution/allplace",
    },
  };
  const begate = {
    main: {
      label: "Be Gate",
      location: "smart-solution/begate",
    },
  };
  const cmsmanager = {
    main: {
      label: "CMS Manager",
      location: "smart-solution/cmsmanager",
    },
  };
  const privateConnectManager = {
    main: {
      label: "HP Poly Connect Manager",
      location: "smart-solution/privateConnectManager",
    },
  };
  const deviceOne = {
    main: {
      label: "Device One",
      location: "smart-solution/deviceOne",
    },
  };
  const mediLink = {
    main: {
      label: "MediLink",
      location: "smart-solution/mediLink",
    },
  };

  const zoom = {
    main: {
      label: "Zoom",
      // location: "zoom",
    },
  };
  const g2b = {
    main: {
      label: "나라장터",
      // location: "g2b",
    },
  };

  const company = {
    main: {
      label: "Company",
      // location: "company",
    },
    sub: [
      {
        label: "회사소개",
        location: "about",
      },
      {
        label: "CEO 인사말",
        location: "about#ceo",
      },
      {
        label: "고객사",
        // location: "company/clients",
      },
      {
        label: "사업실적",
        // location: "company/businessPerformance",
      },
      {
        label: "오시는 길",
        // location: "company/directions",
      },
    ],
  };

  const mediaCenter = {
    main: {
      label: "Media Center",
      // location: "mediaCenter",
    },
    sub: [
      {
        label: "News",
        // location: "news",
      },
      {
        label: "Media & Video",
        // location: "media",
      },
    ],
  };

  const customerCenter = {
    main: {
      label: "Customer Center",
      // location: "customerCenter",
    },
    sub: [
      {
        label: "상담문의",
        // location: "consultation",
      },
      {
        label: "제휴/제안문의",
        // location: "partnership",
      },
    ],
  };
  return (
    <div className={style.sitemap_wrap}>
      <div className={style.sitemap_field}>
        {/* 스마트워크 스페이스 */}
        <SitemapItem page={space} />
        {/* 하이브리드 스마트 강의실/교실 */}
        <SitemapItem page={lecture} />
        {/* 스마트 텔레헬스 시스템 */}
        <SitemapItem page={telehelth} />
        {/* 하이브리드 스마트 카페/도서관 */}
        {/* <SitemapItem page={cafe} /> */}
      </div>
      <div className={style.sitemap_field}>
        {/* AI 화상회의 장비, neat */}
        <SitemapItem page={neat} />
        {/* 무선 프레젠테이션 시스템, ClickShare */}
        <SitemapItem page={clickshare} />
      </div>
      <div className={style.sitemap_field}>
        {/* All Place */}
        <SitemapItem page={allplace} />
        {/* Be Gate */}
        <SitemapItem page={begate} />
        {/* CMS Manager */}
        <SitemapItem page={cmsmanager} />
        {/* HP Poly Connect Manager */}
        <SitemapItem page={privateConnectManager} />
        {/* Device One */}
        <SitemapItem page={deviceOne} />
        {/* MediLink */}
        <SitemapItem page={mediLink} />
      </div>
      <div className={style.sitemap_field}>
        {/* Zoom */}
        <SitemapItem page={zoom} />
        {/* 나라장터 */}
        <SitemapItem page={g2b} />
      </div>
      <div className={style.sitemap_field}>
        {/* Company */}
        <SitemapItem page={company} />
        {/* Media Center */}
        <SitemapItem page={mediaCenter} />
        {/* Customer Center */}
        <SitemapItem page={customerCenter} />
      </div>
    </div>
  );
}

export default Sitemap;
